import React from "react";
import logo from 'assets/img/cit_logo.svg'

const Header = () => (
    <div className="logo">
        <img style={{width: "320px"}} src={logo} alt=""/>
    </div>
);

export default Header;
